import alt from 'alt'
import { SearchConsoleSource } from 'sources'
import { createActions } from 'alt-utils/lib/decorators'

@createActions(alt)
export default class SearchConsoleActions {
  constructor() {
    this.generateActions(
      'setConsoleStatus',
      'setConsoleSetupError',
      'setListedSites',
      'setSearchAnalyticsQuery'
    )
  }

  fetchStatus() {
    return SearchConsoleSource.fetchStatus()
      .then(resp => {
        this.setConsoleStatus(resp.data)
      })
  }

  listSites() {
    return SearchConsoleSource.listSites()
      .then(resp => {
        this.setListedSites(resp)
      })
  }

  searchAnalyticsQueryLegacy() {
    return SearchConsoleSource.searchAnalyticsQueryLegacy()
      .then(resp => {
        this.setSearchAnalyticsQuery(resp)
      })
  }

  searchAnalyticsQuery() {
    return SearchConsoleSource.searchAnalyticsQuery()
      .then(resp => {
        this.setSearchAnalyticsQuery(resp)
      })
  }
}



// WEBPACK FOOTER //
// ./app/actions/SearchConsoleActions.js